import { runInAction, isObservableMap, isObservableSet } from 'mobx'

const snapshotValue = (value) => {
    if (Array.isArray(value)) return value.slice()
    if (value instanceof Map || isObservableMap(value)) return new Map(value)
    if (value instanceof Set || isObservableSet(value)) return new Set(value)
    if (value !== null && typeof value === 'object') return { ...value }
    return value
}

const withRollback = async ({
    target, fields = [], action, store, successBody, errorBody, pendingBody, persist, rethrow,
}) => {
    const snapshots = fields.map((field) => [field, snapshotValue(target[field])])

    try {
        const promise = Promise.resolve(action())
        if (pendingBody) {
            store.addPromiseNotification({
                promise,
                pending: pendingBody,
                success: successBody,
                error: errorBody,
                persist,
            })
        }

        const result = await promise
        if (successBody && !pendingBody) store.addNotification({ body: successBody, level: 'success' })
        return result
    } catch (e) {
        runInAction(() => {
            snapshots.forEach(([field, value]) => {
                // restoring the caller's own observable is the whole point of this helper
                // eslint-disable-next-line no-param-reassign
                target[field] = value
            })
        })
        console.error(e)
        if (!pendingBody) {
            const body = typeof errorBody === 'function' ? errorBody(e) : errorBody
            store.handleError({ body, level: 'error' })
        }
        if (rethrow) throw e
        return undefined
    }
}

export default withRollback
